import { useState } from "react";
import { toast } from "sonner";
import { submitContact } from "../lib/api";
import { Send, Loader2 } from "lucide-react";

const initial = {
  full_name: "",
  email: "",
  phone: "",
  subject: "",
  message: "",
};

export const ContactForm = () => {
  const [form, setForm] = useState(initial);
  const [loading, setLoading] = useState(false);

  const onChange = (e) =>
    setForm((s) => ({ ...s, [e.target.name]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.full_name || !form.email || !form.subject || !form.message) {
      toast.error("Please complete all required fields.");
      return;
    }
    setLoading(true);
    try {
      await submitContact(form);
      toast.success("Message received. We'll reply within one business day.");
      setForm(initial);
    } catch (err) {
      toast.error("Something went wrong. Please call us at 229-733-3500.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={onSubmit}
      data-testid="contact-form"
      className="bg-white border border-gray-200 p-8 lg:p-10 rounded-sm"
    >
      <span className="eyebrow">Send Us A Message</span>
      <h3 className="mt-4 font-serif text-3xl text-[color:var(--isa-navy)] leading-tight">
        We're here to help — and we actually answer.
      </h3>
      <div className="gold-divider" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div>
          <label className="isa-label" htmlFor="contact-name">Full Name *</label>
          <input
            id="contact-name"
            name="full_name"
            type="text"
            className="isa-input"
            value={form.full_name}
            onChange={onChange}
            required
            data-testid="contact-input-name"
          />
        </div>
        <div>
          <label className="isa-label" htmlFor="contact-phone">Phone</label>
          <input
            id="contact-phone"
            name="phone"
            type="tel"
            className="isa-input"
            value={form.phone}
            onChange={onChange}
            data-testid="contact-input-phone"
          />
        </div>
        <div className="md:col-span-2">
          <label className="isa-label" htmlFor="contact-email">Email *</label>
          <input
            id="contact-email"
            name="email"
            type="email"
            className="isa-input"
            value={form.email}
            onChange={onChange}
            required
            data-testid="contact-input-email"
          />
        </div>
        <div className="md:col-span-2">
          <label className="isa-label" htmlFor="contact-subject">Subject *</label>
          <input
            id="contact-subject"
            name="subject"
            type="text"
            className="isa-input"
            value={form.subject}
            onChange={onChange}
            required
            data-testid="contact-input-subject"
            placeholder="How can we help?"
          />
        </div>
        <div className="md:col-span-2">
          <label className="isa-label" htmlFor="contact-message">Message *</label>
          <textarea
            id="contact-message"
            name="message"
            rows={6}
            className="isa-input"
            value={form.message}
            onChange={onChange}
            required
            data-testid="contact-input-message"
          />
        </div>
      </div>

      <button
        type="submit"
        disabled={loading}
        className="btn-primary mt-7 w-full md:w-auto"
        data-testid="contact-submit-button"
      >
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" strokeWidth={1.8} />}
        {loading ? "Sending..." : "Send Message"}
      </button>
    </form>
  );
};

export default ContactForm;
